import { render } from "./Keyboard.vue?vue&type=template&id=4a072344&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"

import "./Keyboard.vue?vue&type=style&index=0&id=4a072344&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a072344"]])

export default __exports__